<template>
    <div class="c-service-measurement">
        <div>
            <a href="#" @click.prevent="startMeasurement()" v-if="!isMeasurementActive(this.serviceAppointment)">{{$t("cocon_list.btn_start_service")}}</a>
            <a href="#" @click.prevent="stopMeasurement()" v-if="isMeasurementActive(this.serviceAppointment)">{{$t("cocon_list.btn_stop_service")}}</a>
            |
            <span v-if="loadingDetail">loading...</span>
            <a v-else href="#" @click.prevent="showDetail()">{{$t('cocon_list.edit_service_measurements')}}</a>
            |
            <router-link :to="{ name: 'appointment-list-completed'}">{{$t('appointment_list.measurements')}}</router-link>
            <span v-if="error" class="error">
                {{$t('generic.cocon_connection_error')}}
            </span>
        </div>
        <div class="appointment-settings" v-if="showEdit">
            <div class="row">
                <label>Naam: </label>
                <input type="text" v-model="serviceAppointment.clients[0].firstname" />
            </div>
            <div class="row">
                <input type="range" v-model.number="serviceAppointment.clients[0].additional_info.size" :min="100" :max="220" />
                <span>{{ serviceAppointment.clients[0].additional_info.size }} cm</span>
                <select v-model="serviceAppointment.clients[0].additional_info.bedside">
                    <option value="left">{{$t('appointment_edit.label_left')}}</option>
                    <option value="right">{{$t('appointment_edit.label_right')}}</option>
                </select>
            </div>
            <button @click.prevent="saveServiceAppointment" class="btn-basic small blue">{{$t('generic.save')}}</button>
        </div>
    </div>
</template>

<script>
import CoconMixin from "@/mixins/CoconMixin";
import {apiStore} from "@/stores/api";
import {measurementStore} from "@/stores/measurement";
import {getDateForPicker} from "@/utils/utils";

export default {
    name : "ServiceAppointment",

    mixins: [
        CoconMixin
    ],

    data() {
        return {
            serviceAppointment: null,
            error: false,
            showEdit: false,
            startDisabled: false,
            loadingDetail :false
        };
    },

    methods: {
        async fetchServiceAppointment() {
            this.serviceAppointment = await apiStore().getServiceAppointment();
        },

        async showDetail() {
            this.loadingDetail = true;
            await this.fetchServiceAppointment();
            this.showEdit = true;
            this.loadingDetail = false;
        },

        async startMeasurement() {
            if (this.startDisabled) {
                return;
            }

            if (this.serviceAppointment === null) {
                await this.fetchServiceAppointment();
            }

            const date = getDateForPicker(new Date());
            const time = new Date().toLocaleTimeString("nl-NL", {hour: "2-digit", minute: "2-digit"});
            this.serviceAppointment.date = date + " " + time;
            this.startDisabled = true;
            this.serviceAppointment = await apiStore().updateAppointment(this.serviceAppointment);
            this.startDisabled = false;

            if (this.isCoconConnected(0)) {
                const data = {
                    appointment_id : this.serviceAppointment.id,
                    appointment: this.serviceAppointment,
                    auto_print: false,
                    print_language : "nl",
                    visitors : this.serviceAppointment.clients,
                    cocon : 0,
                    type: "SERVICE",
                    service:true,
                    language : this.$i18n.locale
                };

                measurementStore().startMeasurement(data);
                this.error = false;
            } else {
                this.error = true;
            }
        },

        stopMeasurement() {
            measurementStore().stopMeasurement(0);
        },

        async saveServiceAppointment() {
            await apiStore().updateAppointment(this.serviceAppointment);
            this.showEdit = false;
        }
    }
};
</script>

<style lang="scss" scoped>
    .c-service-measurement {
        position: absolute;
        bottom: 0;
    }

    .links {
        margin-left: 1rem;
        margin-top: .5rem;
    }

    .error {
        color: red;
        font-style: italic;
    }

    input[type=range] {
        -webkit-appearance: none;
        width: 10rem;
        height: .5rem;
        outline: none;
        -webkit-transition: .2s;
        transition: opacity .2s;

        &::-webkit-slider-thumb {
            -webkit-appearance: none;
            appearance: none;
            width: 1rem;
            height: 1rem;
            border-radius: 1rem;
            background: $color-blue;
            cursor: pointer;
        }
    }

    select {
        font-size: 0.8rem;
        padding: 0.2rem;
        margin: 0 0.25rem;
    }

    input[type=text] {
        font-size: 1rem;
        padding: .25rem;
    }

    .appointment-settings {
        margin-top: 1rem;

        .row {
            margin-bottom: 0.5rem;
        }
    }
</style>